document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.querySelector('.scd__wrapper') || document.body;
  const messageBox = cartDrawer.querySelector('#coupon-messages');

  // ---- Show any pending message left over from before the page reloaded ----
  const pendingMsg = sessionStorage.getItem('coupon-result-message');
  if (pendingMsg && messageBox) {
    messageBox.innerHTML = pendingMsg;
    sessionStorage.removeItem('coupon-result-message');
  }

  // ---- On every load, check if a discount is currently active and inject its line ----
  fetch('/cart.js', { credentials: 'same-origin' })
    .then((res) => res.json())
    .then((cart) => injectDiscountLine(cart))
    .catch(() => {});

  function injectDiscountLine(cart) {
    // Remove any previously injected line first, to avoid duplicates on repeated calls
    const existing = cartDrawer.querySelector('#injected-discount-line');
    if (existing) existing.remove();

    const cartDiscounts = cart.cart_level_discount_applications || [];
    if (!cartDiscounts.length) return; // nothing applied, nothing to show

    const title = cartDiscounts[0].title || 'Discount';
    const amount = cartDiscounts[0].total_allocated_amount;
    const amountText = amount ? `- ₹${(amount / 100).toFixed(2)}` : '';

    const line = document.createElement('div');
    line.id = 'injected-discount-line';
    line.style.cssText =
      'display:flex;justify-content:space-between;padding:6px 0;color:green;font-size:14px;';
    line.innerHTML = `<span>🏷️ ${title}</span><span>${amountText}</span>`;

    // TODO: Update this selector to match wherever your drawer shows totals/subtotal.
    // Common candidates — inspect your drawer HTML and adjust:
    const totalsContainer =
      cartDrawer.querySelector('.scd__totals') ||
      cartDrawer.querySelector('.scd__subtotal') ||
      cartDrawer.querySelector('.drawer__footer') ||
      cartDrawer.querySelector('.cart-drawer__footer');

    if (totalsContainer) {
      totalsContainer.insertAdjacentElement('beforebegin', line);
    } else if (messageBox) {
      // Fallback: at least show it near the coupon input if we can't find totals area
      messageBox.insertAdjacentElement('afterend', line);
    }
  }

  cartDrawer.addEventListener('click', function (e) {
    // ---- Handle SAVE (apply coupon) — reloads page ----
    const saveBtn = e.target.closest('.btn-save');
    if (saveBtn && saveBtn.dataset.action === 'coupon') {
      const input = cartDrawer.querySelector('.scd__discount_code');
      const code = input ? input.value.trim() : '';

      if (!code) return;

      if (messageBox) {
        messageBox.innerHTML = '<p style="color:#888;">Applying code...</p>';
      }

      fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' })
        .then(() => fetch('/cart.js', { credentials: 'same-origin' }))
        .then((res) => res.json())
        .then((cart) => {
          const codeUpper = code.toUpperCase();

          const cartLevelMatch = (cart.cart_level_discount_applications || []).some(
            (d) => d.title && d.title.toUpperCase() === codeUpper
          );

          const lineLevelMatch = (cart.items || []).some((item) =>
            (item.discounts || []).some(
              (d) => d.title && d.title.toUpperCase() === codeUpper
            )
          );

          const isValid = cartLevelMatch || lineLevelMatch;
          let resultHTML = '';

          if (isValid) {
            resultHTML = `<p style="color:green;">✅ "${code}" applied successfully!</p>`;

            if (codeUpper === 'FREESHIP') {
              const threshold = 4000000;
              if (cart.total_price < threshold) {
                const remaining = ((threshold - cart.total_price) / 100).toFixed(0);
                resultHTML += `<p style="color:#b8860b;">Add ₹${remaining} more to unlock free shipping.</p>`;
              } else {
                resultHTML += `<p style="color:green;">🎉 Free shipping unlocked!</p>`;
              }
            }
          } else {
            resultHTML = `<p style="color:red;">❌ "${code}" is invalid or not applicable.</p>`;
          }

          sessionStorage.setItem('coupon-result-message', resultHTML);
          sessionStorage.setItem('reopen-coupon-drawer', 'true');
          window.location.reload();
        })
        .catch(() => {
          sessionStorage.setItem(
            'coupon-result-message',
            '<p style="color:red;">Something went wrong. Please try again.</p>'
          );
          sessionStorage.setItem('reopen-coupon-drawer', 'true');
          window.location.reload();
        });

      return; // stop here so it doesn't also check for remove button
    }

    // ---- Handle REMOVE — stays in-drawer, no reload ----
    const removeBtn = e.target.closest('.remove-discount-btn');
    if (removeBtn) {
      if (messageBox) {
        messageBox.innerHTML = '<p style="color:#888;">Removing code...</p>';
      }

      fetch('/discount/', { credentials: 'same-origin' })
        .then(() => fetch('/cart.js', { credentials: 'same-origin' }))
        .then((res) => res.json())
        .then((cart) => {
          if (messageBox) {
            messageBox.innerHTML = '<p style="color:#555;">Coupon removed.</p>';
          }
          injectDiscountLine(cart); // will remove the line since no discount now applied
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        })
        .catch(() => {
          if (messageBox) {
            messageBox.innerHTML =
              '<p style="color:red;">Failed to remove coupon. Please try again.</p>';
          }
        });
    }
  });
});